import React, { useState } from "react";
import {Accordion,AccordionSummary,AppBar,Box,CardContent,Container,Drawer,List,ListItem,ListItemIcon,ListItemText,Stack,Toolbar,Typography} from "@mui/material";
import { useContext } from "react";
import { Update } from "../App";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import ExploreIcon from "@mui/icons-material/Explore";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LoginIcon from "@mui/icons-material/Login";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import { Link as RouterLink, useNavigate } from "react-router-dom"; // Import Link component from React Router
import FitbitIcon from "@mui/icons-material/Fitbit";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
    width: 32,
    height: 32,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));


const Navbar = () => {
  const {  setNav, nav, displayAppBar,toggleColorMode } = useContext(Update);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  function handleOpenNavMenu() {
    setOpen(true);
  }
  
  const [open, setOpen] = useState(false);
  function handleDrawerClick() {
    setOpen(false);
  }
  const navigate=useNavigate()
  return (
    <Box style={{ display: displayAppBar }}>
      <AppBar position="static" color="error" >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <MonitorHeartIcon
              sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
            />
            <Stack
              direction="row"
              spacing={5}
              sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
            >
            <Typography
              variant="h6"
              noWrap
              onClick={()=>{navigate("/")}}
              sx={{
                cursor:"pointer",
                mr: 2,
                ml: 1,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              FitFinder
            </Typography>
              <Typography
                sx={{
                cursor:"pointer",
                  fontSize: { md: "1.8vw", lg: "1.4vw", xl: "1.2vw" },
                  textDecoration: "none",
                  color: "whitesmoke",
                }}
                onClick={()=>{navigate("/")}}
              >
                Home
              </Typography>
              <Typography
                sx={{
                cursor:"pointer",
                  fontSize: { md: "1.8vw", lg: "1.4vw", xl: "1.2vw" },
                  textDecoration: "none",
                  color: "whitesmoke",
                }}
                onClick={()=>{navigate("/explore")}}
              >
                Explore
              </Typography>
              <Typography
                id="basic-button"
                aria-controls={openMenu ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? "true" : undefined}
                onClick={handleClick}
                sx={{
                cursor:"pointer",
                  fontSize: { md: "1.8vw", lg: "1.4vw", xl: "1.2vw" },
                  textDecoration: "none",
                  color: "whitesmoke",
                }}
              >
                Workout
              </Typography>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  component={RouterLink}
                  onClick={handleClose}
                  to="/gym/traninggym"
                >
                  Gym
                </MenuItem>
                <MenuItem
                  component={RouterLink}
                  onClick={handleClose}
                  to="/homeworkout"
                >
                  Home Workout
                </MenuItem>
                <MenuItem
                  component={RouterLink}
                  onClick={handleClose}
                  to="/yoga"
                >
                  Yoga
                </MenuItem>
              </Menu>
              <Typography
                sx={{
                cursor:"pointer",
                  fontSize: { md: "1.8vw", lg: "1.4vw", xl: "1.2vw" },
                  textDecoration: "none",
                  color: "whitesmoke",
                }}
                onClick={()=>{navigate("/dashboard")}}
              >
                Dashboard
              </Typography>
              {nav === 0 ? (
                <Typography
                  sx={{
                cursor:"pointer",
                    fontSize: { md: "1.8vw", lg: "1.4vw", xl: "1.2vw" },
                    textDecoration: "none",
                    color: "whitesmoke",
                  }}
                  component={RouterLink}
                  to="/login"
                >
                  Login
                </Typography>
              ) : (
                <Typography
                  component={RouterLink}
                  to="/login"
                  sx={{
                cursor:"pointer",
                    fontSize: { md: "1.8vw", lg: "1.4vw", xl: "1.2vw" },
                    textDecoration: "none",
                    color: "whitesmoke",
                  }}
                  onClick={() => {
                    document.cookie = "_hash=b229jjcWX9sczZSgE3hL";
                    setNav(0);
                  }}
                >
                  Logout
                </Typography>
              )}
                         <Typography> <MaterialUISwitch onChange={toggleColorMode} /></Typography>

            </Stack>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                open={open}
                onClose={handleDrawerClick}
              >
                <List>
                  <ListItem onClick={handleDrawerClick} component={RouterLink} to="/">
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <HomeIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText sx={{ color: "grey" }} primary="Home" />
                  </ListItem>
                  <ListItem onClick={handleDrawerClick} component={RouterLink} to="/explore">
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <ExploreIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText sx={{ color: "grey" }} primary="Explore" />
                  </ListItem>

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{ color: "grey" }}>
                        <FitnessCenterIcon sx={{ mr: "32px" }} />
                        Workout
                      </Typography>
                    </AccordionSummary>

                    <List>
                      <ListItem onClick={handleDrawerClick} component={RouterLink} to="/gym/traninggym">
                        <ListItemIcon>
                          <IconButton>
                            <DirectionsRunIcon />
                          </IconButton>
                        </ListItemIcon>
                        <ListItemText sx={{ color: "grey" }} primary="Gym" />
                      </ListItem>
                      <ListItem onClick={handleDrawerClick} component={RouterLink} to="homeworkout">
                        <ListItemIcon>
                          <IconButton>
                            <FitbitIcon />
                          </IconButton>
                        </ListItemIcon>
                        <ListItemText
                          sx={{ color: "grey" }}
                          primary="Home Workout"
                        />
                      </ListItem>
                      <ListItem onClick={handleDrawerClick} component={RouterLink} to="yoga">
                        <ListItemIcon>
                          <IconButton>
                            <SelfImprovementIcon />
                          </IconButton>
                        </ListItemIcon>
                        <ListItemText sx={{ color: "grey" }} primary="Yoga" />
                      </ListItem>
                    </List>
                  </Accordion>
                  <ListItem onClick={handleDrawerClick} component={RouterLink} to="/dashboard">
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <DashboardIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText sx={{ color: "grey" }} primary="Dashboard" />
                  </ListItem>
                  {nav === 0 ? (
                    <ListItem onClick={handleDrawerClick} component={RouterLink} to="/login">
                      <ListItemIcon>
                        <IconButton edge="start" color="inherit">
                          <LoginIcon />
                        </IconButton>
                      </ListItemIcon>
                      <ListItemText sx={{ color: "grey" }} primary="Login" />
                    </ListItem>
                  ) : (
                    <ListItem
                      component={RouterLink}
                      to="/login"
                      onClick={() => {
                        document.cookie = "_hash=b229jjcWX9sczZSgE3hL";
                        setNav(0);
                      }}
                    >
                      <ListItemIcon>
                        <IconButton edge="start" color="inherit">
                          <LogoutIcon />
                        </IconButton>
                      </ListItemIcon>
                      <ListItemText sx={{ color: "grey" }} primary="Logout" />
                    </ListItem>
                  )}
                </List>
              </Drawer>
            </Box>
            <MonitorHeartIcon
              sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
            />
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 18,
                display: { sm: "flex", md: "none" },
                flxGrow: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              FitFinder
            </Typography>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

export default Navbar;
